/* ─── SECRET BY MOLLIE — THEME JS ─── */

// ── GLITTER CANVAS PARTICLES ──
(function() {
  const canvas = document.getElementById('glitter-canvas');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  function resize() { canvas.width = window.innerWidth; canvas.height = window.innerHeight; }
  resize();
  window.addEventListener('resize', resize);

  const colors = ['#EC4899','#A855F7','#F59E0B','#C4B5FD','#F9A8D4','#FDE68A','#2DD4BF'];
  const particles = [];

  class Particle {
    constructor(x, y, fromMouse) {
      this.x = x || Math.random() * canvas.width;
      this.y = y || Math.random() * canvas.height;
      this.size = fromMouse ? Math.random() * 4 + 2 : Math.random() * 2 + 0.5;
      this.color = colors[Math.floor(Math.random() * colors.length)];
      this.vx = (Math.random() - 0.5) * (fromMouse ? 3 : 0.6);
      this.vy = fromMouse ? Math.random() * -3 - 1 : Math.random() * -0.8 - 0.2;
      this.alpha = fromMouse ? 1 : Math.random() * 0.6 + 0.2;
      this.decay = fromMouse ? 0.022 : 0.003;
      this.rotation = Math.random() * Math.PI * 2;
      this.rotSpeed = (Math.random() - 0.5) * 0.1;
    }
    update() {
      this.x += this.vx;
      this.y += this.vy;
      this.vy += 0.02;
      this.alpha -= this.decay;
      this.rotation += this.rotSpeed;
    }
    draw() {
      ctx.save();
      ctx.globalAlpha = Math.max(0, this.alpha);
      ctx.translate(this.x, this.y);
      ctx.rotate(this.rotation);
      ctx.fillStyle = this.color;
      ctx.fillRect(-this.size / 2, -this.size / 2, this.size, this.size);
      ctx.restore();
    }
  }

  for (let i = 0; i < 50; i++) particles.push(new Particle());

  let lastX = 0, lastY = 0;
  document.addEventListener('mousemove', e => {
    if (Math.abs(e.clientX - lastX) + Math.abs(e.clientY - lastY) > 6) {
      for (let i = 0; i < 3; i++) {
        particles.push(new Particle(
          e.clientX + (Math.random() - 0.5) * 10,
          e.clientY + (Math.random() - 0.5) * 10,
          true
        ));
      }
      lastX = e.clientX;
      lastY = e.clientY;
    }
    const glow = document.getElementById('cursor-glow');
    if (glow) {
      glow.style.left = e.clientX + 'px';
      glow.style.top = e.clientY + 'px';
    }
  });

  function loop() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = particles.length - 1; i >= 0; i--) {
      particles[i].update();
      particles[i].draw();
      if (particles[i].alpha <= 0) {
        if (i < 50) particles[i] = new Particle();
        else particles.splice(i, 1);
      }
    }
    requestAnimationFrame(loop);
  }
  loop();

  window.__themeParticles = particles;
  window.__themeParticle = Particle;
})();

// ── NAV SCROLL EFFECT ──
window.addEventListener('scroll', () => {
  const nav = document.querySelector('.site-nav');
  if (nav) nav.classList.toggle('scrolled', window.scrollY > 60);
  // parallax blobs
  const b1 = document.querySelector('.b1');
  const b2 = document.querySelector('.b2');
  if (b1) b1.style.transform = `translateY(${window.scrollY * 0.08}px)`;
  if (b2) b2.style.transform = `translateY(${window.scrollY * -0.06}px)`;
});

// ── SCROLL FADE-IN ──
(function() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach((e, i) => {
      if (e.isIntersecting) {
        setTimeout(() => e.target.classList.add('v'), i * 55);
        obs.unobserve(e.target);
      }
    });
  }, { threshold: 0.08 });
  document.querySelectorAll('.fu,.fl,.fr,.fsc').forEach(el => obs.observe(el));
})();

// ── PDP TABS ──
document.querySelectorAll('.tab').forEach(t => {
  t.addEventListener('click', () => {
    document.querySelectorAll('.tab').forEach(x => x.classList.remove('active'));
    document.querySelectorAll('.tab-content').forEach(x => x.classList.remove('active'));
    t.classList.add('active');
    const tc = document.getElementById('tab-' + t.dataset.tab);
    if (tc) tc.classList.add('active');
  });
});

// ── PDP THUMBNAIL SWITCHING ──
document.querySelectorAll('.pdp-thumb').forEach(th => {
  th.addEventListener('click', () => {
    document.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('active'));
    th.classList.add('active');
    const main = document.querySelector('.pdp-main-img');
    const imgSrc = th.querySelector('img').src;
    if (main && imgSrc) main.src = imgSrc;
  });
});

// ── PDP QUANTITY ──
(function() {
  const minus = document.getElementById('qty-minus');
  const plus = document.getElementById('qty-plus');
  const val = document.getElementById('qty-val');
  if (!minus || !plus || !val) return;
  minus.addEventListener('click', () => {
    let q = parseInt(val.value) || 1;
    if (q > 1) { q--; val.value = q; }
  });
  plus.addEventListener('click', () => {
    let q = parseInt(val.value) || 1;
    q++; val.value = q;
  });
})();

// ── PDP VARIANT PICKER ──
(function() {
  const pills = document.querySelectorAll('.variant-pill');
  pills.forEach(p => {
    p.addEventListener('click', () => {
      pills.forEach(x => x.classList.remove('active'));
      p.classList.add('active');
      const variantId = p.dataset.variantId;
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantId) variantInput.value = variantId;
      const shadeName = document.getElementById('shade-name');
      if (shadeName) shadeName.textContent = p.dataset.variantTitle || '';
    });
  });
})();

// ── ADD TO CART ──
document.querySelectorAll('.add-cart-form').forEach(form => {
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('.add-cart-btn');
    if (!btn) return;
    const origText = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = '✦ Adding...';
    const formData = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: formData
      });
      if (!res.ok) throw new Error('Add to cart failed');
      btn.innerHTML = '✓ Added to Bag!';
      btn.style.background = 'linear-gradient(135deg,#22C55E,#16A34A)';
      // particle burst
      if (window.__themeParticles && window.__themeParticle) {
        const rect = btn.getBoundingClientRect();
        for (let i = 0; i < 16; i++) {
          window.__themeParticles.push(new window.__themeParticle(
            rect.left + rect.width/2,
            rect.top + rect.height/2,
            true
          ));
        }
      }
      // update cart count in nav
      updateCartCount();
      setTimeout(() => {
        btn.disabled = false;
        btn.innerHTML = origText;
        btn.style.background = '';
      }, 2000);
    } catch (err) {
      btn.innerHTML = origText;
      btn.disabled = false;
      alert('Could not add to bag. Please try again.');
    }
  });
});

// ── QUICK ADD (homepage product card +) ──
document.querySelectorAll('.quick-add-btn').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.disabled = true;
    const orig = btn.innerHTML;
    btn.innerHTML = '...';
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      if (!res.ok) throw new Error();
      btn.innerHTML = '✓';
      btn.style.background = 'linear-gradient(135deg,#22C55E,#16A34A)';
      // particles
      if (window.__themeParticles && window.__themeParticle) {
        const rect = btn.getBoundingClientRect();
        for (let i = 0; i < 12; i++) {
          window.__themeParticles.push(new window.__themeParticle(
            rect.left + rect.width/2,
            rect.top + rect.height/2,
            true
          ));
        }
      }
      updateCartCount();
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.style.background = '';
        btn.disabled = false;
      }, 1500);
    } catch (err) {
      btn.innerHTML = orig;
      btn.disabled = false;
    }
  });
});

// ── CART COUNT UPDATER ──
async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const el = document.querySelector('.cart-count');
    if (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    }
  } catch (e) {}
}

// ── CART PAGE QTY UPDATE ──
document.querySelectorAll('.cart-qty-input').forEach(inp => {
  inp.addEventListener('change', async () => {
    const line = inp.dataset.line;
    const qty = inp.value;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: parseInt(qty) })
      });
      if (res.ok) location.reload();
    } catch (e) {}
  });
});
document.querySelectorAll('.cart-remove').forEach(btn => {
  btn.addEventListener('click', async () => {
    const line = btn.dataset.line;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(line), quantity: 0 })
      });
      if (res.ok) location.reload();
    } catch (e) {}
  });
});

// ── INIT CART COUNT ON LOAD ──
document.addEventListener('DOMContentLoaded', updateCartCount);
